<template>
  <div>
    <html>
      <head> </head>
      <body>
        <div class="container">
          <div class="logo"></div>
          <span class="pointPath">{{ pointPath }}</span>
          <h2>{{ $t("vibration_analyze_report.fault_report") }}</h2>
          <span style="position: absolute; right: 30px; top: 50px">{{
            date
          }}</span>
          <br />
          <br />
          <table
            style="
              width: 80%;
              height: 100px;
              margin: auto;
              border-collapse: separate;
              border-spacing: 0px;
            "
          >
            <tr style="height: 20px">
              <th style="font-size: 17px">
                {{ $t("vibration_analyze_report.severity_name") }}
              </th>
              <th style="font-size: 17px">
                {{ $t("vibration_analyze_report.predicted_fault") }}
              </th>
              <th style="font-size: 17px">
                {{ $t("vibration_analyze_report.description") }}
              </th>
              <th style="font-size: 17px">
                {{ $t("vibration_analyze_report.indication") }}
              </th>
              <th style="font-size: 17px">
                {{ $t("vibration_analyze_report.cause") }}
              </th>
              <th style="font-size: 18px">
                {{ $t("vibration_analyze_report.suggestion") }}
              </th>
            </tr>
            <tr>
              <td>
                <table style="height: 80%; width: 100%">
                  <tr>
                    <td>
                      <div class="circle">
                        <div class="circle-outline critical"></div>
                        <div
                          class="circle-fill"
                          v-bind:class="criticalClass"
                        ></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="circle">
                        <div class="circle-outline hazard"></div>
                        <div
                          class="circle-fill"
                          v-bind:class="hazardClass"
                        ></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="circle">
                        <div class="circle-outline attention"></div>
                        <div
                          class="circle-fill"
                          v-bind:class="attentionClass"
                        ></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="circle">
                        <div class="circle-outline healthy"></div>
                        <div
                          class="circle-fill"
                          v-bind:class="healthyClass"
                        ></div>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <h2>{{ $t(`vibration_analyze_report.${faultType}`) }}</h2>
                <div style="font-size: 16px" v-html="faultImage" />
              </td>
              <td>
                <div style="font-size: 16px" v-html="description" />
              </td>
              <td>
                <div style="font-size: 16px" v-html="indication" />
              </td>
              <td>
                <div style="font-size: 16px" v-html="cause" />
              </td>
              <td style="position: relative; font-size: 16px">
                <div v-html="suggestion" />
              </td>
            </tr>
          </table>
          <div style="position: absolute; bottom: 20px; left: 30px">
            <strong style="margin-right:5px">{{
              $t("vibration_analyze_report.technical_report")
            }}</strong            >|<span style="color: rgb(255, 102, 0)">
              Sensemore Smart Machine Health
            </span>
          </div>
          <div style="position: absolute; bottom: 20px; right: 30px">
          
                      <div style="display:inline-block;width:10px; height:10px; background:rgb(249, 210, 20); border:1px solid gray; margin-right:3px"> </div>{{$t("faultReport.attention_description")}}
             <div style="display:inline-block;width:10px; height:10px; background:rgb(249, 147, 20); border:1px solid gray; margin-right:3px"> </div>{{$t("faultReport.hazard_description")}}
             <div style="display:inline-block;width:10px; height:10px; background:rgb(249, 20, 20); border:1px solid gray; margin-right:3px"> </div>{{$t("faultReport.critical_description")}}
          </div>
        </div>
      </body>
    </html>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "Shipping_Cargo",
  components: {},
  props: {
    form: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    pointPath() {
      return this.form.pointPath;
    },
    description() {
      return this.form.info.description[this.$i18n.locale];
    },
    indication() {
      return this.form.info.indication[this.$i18n.locale];
    },
    cause() {
      return this.form.info.cause[this.$i18n.locale];
    },
    suggestion() {
      return this.form.info.suggestion[this.$i18n.locale];
    },
    faultType() {
      return this.form.faultType;
    },
    faultImage() {
      return this.form.image;
    },
    date() {
      return dayjs(this.form.createdAt).format("DD-MM-YYYY");
    },
    healthyClass() {
      return {
        healthy: this.form.severity == "healthy",
      };
    },
    attentionClass() {
      return {
        attention: this.form.severity == "attention",
      };
    },
    hazardClass() {
      return {
        hazard: this.form.severity == "hazard",
      };
    },
    criticalClass() {
      return {
        critical: this.form.severity == "critical",
      };
    },
  },
  created() {},
  mounted() {},
  methods: {
    tableLocazation(title) {
      return this.tableTitle[title][this.printForm.language];
    },
    KeyNames(index, type) {
      return this[type][index][this.printForm.language];
    },
  },
  watch: {},
};
</script>
<style scoped>
.logo {
  margin: auto;
  background-position: center;
  width: 245px;
  background-size: cover;
  flex: 1;
  height: 46px;
  background-image: url("data:image/png;base64,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");
}
div {
  word-break: keep-all;
}
html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
}

* {
  flex: 1;
  font-family: Arial, Helvetica, sans-serif;
}

body {
  margin: 0;
  padding: 0;
  display: flex;
  border: 1px solid black;
  max-width: calc(100% - 4px);
  max-height: calc(100% - 4px);
  width: calc(100% - 4px);
  height: calc(100% - 4px);
}

@media print {
  @page {
    size: landscape;
  }
}

table {
  font-size: 10px;
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td:first-child {
  width: 50px;
}

td:nth-child(2) {
  width: 300px;
}

td:nth-child(3) {
  width: 300px;
}

td:nth-child(4) {
  width: 300px;
}

td:nth-child(5) {
  width: 300px;
}

td:nth-child(6) {
  width: 300px;
}

td,
th {
  text-align: center;
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  border: 0;
  color: black;
}

.circle {
  position: relative;
  height: 55px;
  width: 55px;
}

.circle-outline {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  border-width: 2px;
  left: 0;
  top: 0;
  border-style: solid;
}

.circle-fill {
  display: none;
  width: 100%;
  height: 100%;
  left: 2px;
  top: 2px;
  border-radius: 50%;
  background-color: transparent;
  position: absolute;
}


.circle-outline.critical {
  border-color: rgb(249, 20, 20);
}

.circle-fill.critical {
  background-color: rgb(249, 20, 20);
}

.circle-outline.hazard {
  border-color: rgb(249, 147, 20);
}

.circle-fill.hazard {
  background-color: rgb(249, 147, 20);
}

.circle-outline.attention {
  border-color: rgb(249, 210, 20);
}

.circle-fill.attention {
  background-color: rgb(249, 210, 20);
}

.circle-outline.healthy {
  border-color: rgb(20, 249, 31);
}

.circle-fill.healthy {
  background-color: rgb(20, 249, 31);
}

.circle-fill.circle-fill.healthy {
  display: block;
}
.circle-fill.circle-fill.attention {
  display: block;
}
.circle-fill.circle-fill.hazard {
  display: block;
}
.circle-fill.circle-fill.critical {
  display: block;
}
.container {
  border: 1px solid black;
  flex: 1;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
  padding-left: 0px;
  padding-right: 0px;
}

.pointPath {
  left: 30px;
  position: absolute;
  top: 50px;
  font-size: 15px;
}
</style>
<style scoped>
.div {
  margin: 10px;
}
.border {
  border: 1px solid #ebeef5;
}
.receiver {
  margin-top: 15px;
}
.layout {
  display: flex;
  flex-direction: row;
}
.landing {
  padding-right: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.el-menu-vertical {
  min-height: calc(100vh - 60px);
}
.header {
  display: flex;
  color: white;
  align-items: center;
  flex-direction: row;
  background: #343a40;
  padding-left: 30px;
  padding-right: 15px;
  height: 40px;
}
</style>